import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Breadcrumb, Button, Confirm } from 'semantic-ui-react'
import { 
  MainBodyContent,
  StatusTag,
} from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { 
  bgCompanyReportPath,
  bgCompanyReportDetailPath
} from 'routes'
import { 
  BottomActionsContainer,
  TitleCont
} from './styled'
import { 
  getBGCompanyDetail,
  updateBGCompany
} from 'ducks/bgCompany'
import { getBankOwners } from 'ducks/bankGuarantee'
import { validateField } from '../helper'
import { getVendors, getCompanies, getCustomers } from 'ducks/options'
import { statusColor } from '../AttributeData'
import BankGuaranteeInformation from '../Shareds/BankGuaranteeInformation'
import GeneralInformation from '../Shareds/GeneralInformation'
import ContactComponent from '../Shareds/Contact'
import AttachmentComponent from '../Shareds/Attachment'
import BankGuaranteeRelated from '../Shareds/BankGuaranteeRelated'

const EditBankGuaranteeCompany = (props) => {

  const { 
    valueForm, 
    history,
    isDetail = false
  } = props

  const actionName = React.useRef('')
  const isBalanceLower = React.useRef(false)
  const confirmBalanceLower = React.useRef(false)
  const warningMessageBalanceLower = React.useRef('')
  const [showConfirm, setShowConfirm] = React.useState(false)

  React.useEffect(()=>{ // check to detil mode
    if(valueForm.id){
      if([0].indexOf(valueForm.status)<0){
        history.replace(bgCompanyReportDetailPath(valueForm.id))
      }else if(!valueForm.isValid){
        history.replace(bgCompanyReportDetailPath(valueForm.id))
      }
    }
  },[valueForm.id])

  const getConfirmMessage = () =>{
    if(actionName.current == 'Submit'){
      if(isBalanceLower.current){
        return warningMessageBalanceLower.current
      }else {
        return 'Are you sure?'
      }    
    }else{
      return 'Are you sure?'
    }
  }

  React.useEffect(() => {
    props.getBGCompanyDetail(props.match.params.id, history)
    props.getVendors()
    props.getCompanies()
    props.getBankOwners()
    props.getCustomers()
  }, [])

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms)) 
    return sleep(100)
    .then(() => {
      setShowConfirm(true)
    })
  } 

  const cancelConfirm = () =>{
    confirmBalanceLower.current = false
    isBalanceLower.current = false
    warningMessageBalanceLower.current = ''
    setShowConfirm(false)
  }

  const confirmSubmit = () =>{
    setShowConfirm(false)
    props.updateBGCompany(valueForm,actionName.current=='Submit',history,confirmBalanceLower.current,onRequestConfirm)
  }

  const onRequestConfirm = (message) =>{
    confirmBalanceLower.current = true
    isBalanceLower.current = true
    warningMessageBalanceLower.current = message
    setShowConfirm(true)
  }
  
  return (
    <MainBodyContent 
      headerTitle={
        <React.Fragment>
          {`Bank Guarantee Company - ${valueForm.documentNumber||'Edit'}`}
          <StatusTag status={valueForm.status} statusName={valueForm.statusName} style={{background:statusColor[`${valueForm.status}`],marginLeft: '10px'}}/>
        </React.Fragment>
      }
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'BG', content: 'BG Company', link: true, onClick: () => history.push(bgCompanyReportPath) },
              { key: 'BGEdit', content: 'Edit', active: true }
            ]
          }
        />
      }
    >
      <div style={{height:'1rem'}}/>
      <div style={{display:'flex'}}>
        <TitleCont>Document Type : {valueForm.documentType||'-'}</TitleCont>
      </div>
      <GeneralInformation isEdit isDetail={isDetail}/>
      <BankGuaranteeRelated/>
      <BankGuaranteeInformation isEdit/>
      <ContactComponent isEdit/>
      <AttachmentComponent isEdit/>
      <div style={{height:'1rem'}}/>
      <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
        <BottomActionsContainer>
          <Button 
            content='Save' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>{
              actionName.current = 'Save'
            }}
          />
          <Button 
            content='Save & Submit' 
            color='blue' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>{
              actionName.current = 'Submit'
            }}
          />
        </BottomActionsContainer>
      </form>
      <Confirm
        size='tiny'
        open={showConfirm}
        content={getConfirmMessage()}
        onCancel={() => cancelConfirm()}
        onConfirm={() => confirmSubmit()}
      />
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const user = state.authen.user || {}
  const username = user.username || ''
  const valueForm = getFormValues('formBGCompany')(state) || {}

  return ({
    valueForm,
    username,
    initialValues: {
      requesterUser: username,
      attachments: [],
      contacts: [],
      actions:[],
      isContactValid: true,
      ...state.bgCompany.detail.data
    },
  })
}

const mapDispatchToProps = {
  getBGCompanyDetail,
  getVendors, 
  getCompanies,
  getBankOwners,
  updateBGCompany, 
  getCustomers
}

const validate = (values) => {
  let errors = validateField(values)
  return errors
}

const ContForm = reduxForm({
  form: 'formBGCompany',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(EditBankGuaranteeCompany)

export default connect(mapStateToProps, mapDispatchToProps)(ContForm)
